import notification from '../../services/notification-service'

export default {
    name: 'Nav',
    data() {
        return {
            activeRoute: '/home'
        }
    },
    methods: {
        signOut () {
            this.$http.secured.delete('/signin')
              .then(() => {
                delete localStorage.csrf
                delete localStorage.signedIn
                this.$router.replace('/')
               })
               .catch(() => notification.notify(this.$i18n.t('notifications.unfortunately'), this.$i18n.t('notifications.logoutFailed'), 'error'))
            this.$gtag.event('sign-out-click', {
                'event_category': 'authentication',
                'event_label': 'Sign Out'
              })
        }
    },
    created() {
        this.activeRoute = this.$route.path
    }
}